import React, { useState } from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { Icon, Text } from 'components/atoms';

const ImageSelect = ({
  src, alt, isLoading, message
}) => {
  const [isHover, setHover] = useState(false);
  return (
    <Image
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {isHover && (
        <Image.Hover>
          <Icon icon="add_photo" color="#FFF" />
          {message && <Text modifiers={['inverse']}>{message}</Text>}
        </Image.Hover>
      )}
      {isLoading ? <Image.Loading /> : <img src={src} alt={alt} />}
    </Image>
  );
};

const Image = styled.div`
  // width: 165px;
  height: auto;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
  max-width: 500px;
`;

Image.Hover = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: ${props => props.theme.colors.bgHover};
  cursor: pointer;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${props => props.theme.spacing.xs};
`;

Image.Loading = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.greyLighter};
`;

ImageSelect.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  message: PropTypes.string,
};

ImageSelect.defaultProps = {
  isLoading: false,
  message: null,
};

export default ImageSelect;
